/***
*
*   CAMPAIGN
*   Information for user to get help and support
*
**********/

import React, { Fragment, useState, useContext, useEffect } from 'react';
import { ProgressSteps, TextInput, Label, AuthContext } from 'components/lib';
import Style from './resume-campaign.module.scss';
import Astronauta from '../../../../assets/astronauta_listo.svg';

// if (window.performance) {
//   if (performance.navigation.type == 1) {
//     window.location.href = window.location.origin + '/campaign';
//   }
// }

export function CampaignSummary(props){

  // context
  const authContext = useContext(AuthContext);

  // state
  const [subject, setSubject] = useState("");
  const [paragraph1, setParagraph1] = useState("");
  const [paragraph2, setParagraph2] = useState("");
  const [paragraph3, setParagraph3] = useState("");
  const [from, setFrom] = useState("");
  // const [list, setList] = useState("");

  useEffect(() => {
    let referrer = window.performance.navigation.type;  
  }, [])

  const bodyData = (field, value) => {
    if(field === 'subject') setSubject(value);
    if(field === 'paragraph_1') setParagraph1(value);
    if(field === 'paragraph_2') setParagraph2(value);
    if(field === 'paragraph_3') setParagraph3(value);
    if(field === 'from') setFrom(value);
    // if(field === 'list') setList(value);
  }

  return (
    <Fragment>
    
      <div style={{ marginTop: '-40px' }}>
        <ProgressSteps items={[
            { name: 'Crear', url: '/creation', completed: true },
            { name: 'Audiencia', url: '/camp-audience', completed: true },
            { name: 'Plantillas', url: '/theme', completed: true },
            { name: 'Resumen', url: '/summary', completed: true },
            { name: 'Listo', url: '/finish', completed: false },
        ]} marginRight='-15px' shadow/>
      </div>
      
      <div style={{ position: 'relative' }}>
        <div style={{ marginTop: '8em', width: '45%' }}>
          <header className={ Style['resume-title'] }>
            <h2>
              Resumen
            </h2>
          </header>

          <div>Aquí puedes verificar tu campaña antes de enviarla</div>

          <div style={{ float: 'left', marginTop: '2em' }}>
            <Label text='Asunto' weight/>
          </div>
          <TextInput 
            name='subject' 
            onChange={bodyData} 
            value={subject} 
            height={'25px'}
            className={ Style['input-class'] }
          />
          <div style={{ float: 'left', marginTop: '2em' }}>
            <Label text='De' weight/>
          </div>
          <TextInput 
            name='from' 
            onChange={bodyData} 
            value={from} 
            height={'25px'}
            className={ Style['input-class'] }
          />

        </div>

        <div className={ Style['logo-summary'] }>
          <img width={375} height={375} src={ Astronauta } alt='Logo'/>
        </div>
      </div>


      <div style={{ position: 'fixed', bottom: '2em', right: '2em' }}>
        <ProgressSteps items={[
          { name: 'Regresar', url: '/theme', completed: false, iconLeft: 'chevron-left' },
          { name: 'Crear', url: '/finish', completed: true, click: () => {
            localStorage.setItem('api_mail', '1');
            authContext.dispatch({ type: 'ADD_CAMPAIGN', value: { summary: {
              subject,
              from
            } } })
          } },
        ]} marginRight='10px'/>
      </div>
      
    </Fragment>
  )
}